// extracted by mini-css-extract-plugin
export default {"link":"IL-z","disabled":"JL-z"};